module.exports = __webpack_public_path__ + "images/hikakaku-estimateform_zero_sorry1_b107f90a9b4056b1e4eb2676faaaabd8.png";